import Vue from 'vue'
import App from './App'
import router from './router'
import Sentry from '@infiniscene/lib/sentry/client'

Vue.config.productionTip = false
const sentryKey = '9109c07972b34d6f85de0ffb43c38c14'
const sentryAppId = '240875'

Sentry.config(true, `https://${sentryKey}@sentry.io/${sentryAppId}`, {
  "debug": true,
  "environment": "development",
  "sendTimeout": 2,
  "captureUnhandledRejections": true,
  "autoBreadcrumbs": true
})
new Vue({ // eslint-disable-line no-new
  el: '#app',
  router,
  template: '<App/>',
  components: {App}
})



// WEBPACK FOOTER //
// ./client/main.js